import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Collapse, Paper, Tooltip, styled } from "@mui/material";
import { green, yellow } from "@mui/material/colors";
import { Typography } from "@platform/design-system";

import TooltipDocumentUploadStatus from "../../../components/tooltipDocumentUploadStatus";

const DocumentTypePanel = ({
  children,
  isOpen,
  onClick,
  employeeNavigatorManaged,
  title,
  isRequired,
  requiredList,
  optionalList,
}) => {
  const PendingAssignment = () => (
    <Typography display="flex" alignItems="center" justifyContent="center">
      <Tooltip
        arrow
        placement="top"
        title={
          <Typography
            variant="caption"
            component="span"
            color="inherit"
            width="200px"
            textAlign={"center"}
            display="inline-block"
          >
            <strong>
              All uploaded documents must be assigned to a coverage.
            </strong>
          </Typography>
        }
      >
        <InfoOutlinedIcon style={{ color: yellow[800] }} fontSize="small" />
      </Tooltip>
      <StyledLabel color={({ palette }) => palette.neutrals.neutral_700}>
        Coverage Assignments Required
      </StyledLabel>
    </Typography>
  );

  const DocumentsMissing = () => (
    <Typography display="flex" alignItems="center" justifyContent="center">
      <Tooltip
        arrow
        placement="top"
        title={
          <TooltipDocumentUploadStatus
            requiredList={requiredList}
            optionalList={optionalList}
          />
        }
      >
        <InfoOutlinedIcon style={{ color: yellow[800] }} fontSize="small" />
      </Tooltip>
      <StyledLabel color={({ palette }) => palette.neutrals.neutral_700}>
        Documents Required
      </StyledLabel>
    </Typography>
  );

  const EmployeeNavigatorManaged = () => (
    <Typography display="flex" alignItems="center" justifyContent="center">
      <StyledLabel color={({ palette }) => palette.neutrals.neutral_700}>
        Will be pulled from EmployeeNavigator
      </StyledLabel>
    </Typography>
  );

  const AllDocumentsUploaded = () => (
    <Typography display="flex" alignItems="center" justifyContent="center">
      <CheckCircleOutlineOutlinedIcon
        style={{ color: green[800] }}
        fontSize="small"
      />
      <StyledLabel color={({ palette }) => palette.neutrals.neutral_700}>
        Completed
      </StyledLabel>
    </Typography>
  );

  const EmptyTypography = () => <Typography> </Typography>;

  const handleSubTitle = () => {
    const requiredDocumentData = requiredList ? requiredList : [];
    const optionalDocumentData = optionalList ? optionalList : [];
    let isRequiredDocumentMissing = false;
    let isAtleastOneOptionalDocumentUploaded = false;
    requiredDocumentData.forEach((item) => {
      if (item.files?.length === 0) {
        isRequiredDocumentMissing = true;
      }
    });
    optionalDocumentData.forEach((item) => {
      if (item.files?.length > 0) {
        isAtleastOneOptionalDocumentUploaded = true;
      }
    });

    if (employeeNavigatorManaged) {
      return EmployeeNavigatorManaged();
    } else if (isRequired) {
      return PendingAssignment();
    } else if (isRequiredDocumentMissing) {
      return DocumentsMissing();
    } else if (title === "Additional Documents") {
      return EmptyTypography();
    } else if (
      (requiredDocumentData.length && !isRequiredDocumentMissing) ||
      (!requiredDocumentData.length &&
        optionalDocumentData.length &&
        isAtleastOneOptionalDocumentUploaded)
    ) {
      return AllDocumentsUploaded();
    }
    return EmptyTypography();
  };

  return (
    <Paper sx={{ border: "1px solid #F1F0F0", marginBottom: "18px" }}>
      <Box
        data-testid="document-type-panel"
        display="flex"
        onClick={onClick}
        px={2}
        py={2.75}
        gap={1}
        sx={{ cursor: "pointer" }}
      >
        <Typography variant="body-large" flex={2} textAlign="left">
          <strong>{title}</strong>
        </Typography>
        <Box
          flex={4}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          {handleSubTitle()}
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </Box>
      </Box>
      <Collapse
        in={isOpen}
        timeout="auto"
        unmountOnExit
        sx={{ paddingTop: 1, paddingX: 2, paddingBottom: 2 }}
      >
        {children}
      </Collapse>
    </Paper>
  );
};

const StyledLabel = styled(Typography)(({ theme }) => ({
  display: "flex",
  marginLeft: theme.spacing(1),
  fontStyle: "italic",
  fontSize: "0.875rem",
  justifyContent: "center",
}));

export default DocumentTypePanel;
